import { all } from 'redux-saga/effects'

import { receivedSaga } from './received/sagas'
import { sentSaga } from './sent/sagas'

export function* invitesSaga() {
  yield all([receivedSaga(), sentSaga()])
}
